export enum DocumentType {
  CONTRACT = 'CONTRACT',

  OFFER = 'OFFER',

  AGREEMENT = 'AGREEMENT',
}
